import React, { useRef } from 'react';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { FormattedNumber } from 'react-intl';
import ReactToPrint from 'react-to-print';
import { PrintPaymentPlanSummary } from './PrintPaymentPlanSummary';
import { getTemplateString } from 'common/helpers/string';
import { useMediaQuery } from 'react-responsive';
import styles from './PaymentSummaryDetails.module.scss';
import { selectCurrentMarket } from 'features/core/selectors';
import { Market } from 'common/consts/markets';
import { useAppSelector } from 'app/hooks';
import { AddToMonthlyCalendar } from 'common/helpers/AddToMonthlyCalendar';

interface Props {
  PageData?: any;
  Model?: any;
}

const PaymentSummaryDetails = (props: Props) => {
  const { Model, PageData } = props;
  const componentRef = useRef(null);
  const ERROR_ICONS_PATH = `${process.env.PUBLIC_URL}/images/icons/`;
  const paymentCompleteCheck = `${ERROR_ICONS_PATH}/payment-complete-check.svg`;
  const paymentPlanTypeTemplate = getTemplateString(
    PageData?.PaymentInfoThankYouMessage,
  );
  const planDueDateTemplate = getTemplateString(
    PageData?.PaymentInfoDateMessage,
  );
  const installmentMonthTemplate = getTemplateString(
    PageData?.PaymentInfoinstallmentMonthMessage,
  );
  const planDueDateManualTemplate = getTemplateString(
    PageData?.PaymentInfoDateManualMessage,
  );
  const CalendarDescriptionMessageTemplate = getTemplateString(
    PageData?.CalendarDescriptionMessage,
  );
  const isMobileSize = useMediaQuery({ maxWidth: 767 });
  const currentMarket = useAppSelector(selectCurrentMarket);
  const calenderDescription = {
    __html: CalendarDescriptionMessageTemplate
      ? CalendarDescriptionMessageTemplate({})
      : '',
  };
  return (
    <div>
      <section className="CreateRepaymentPlan__section">
        {(currentMarket === Market.PL ||
          currentMarket === Market.BE ||
          currentMarket === Market.NL) && (
          <div className="settlementAgreed">
            <div className="settlementAgreed__section">
              {Model.ForOffer || Model.IsInEditMode ? (
                <h2 className="settlementAgreed__heading">
                  {PageData?.PaymentplanConfirmedSettlementOffer}
                </h2>
              ) : (
                <h2 className="settlementAgreed__heading">
                  {PageData?.PaymentPlanConfirmed}
                </h2>
              )}
              <img
                className="settlementAgreed__icon"
                src={paymentCompleteCheck}
              />
              {Model.ForOffer || Model.IsInEditMode ? (
                <p className="settlementAgreed__message">
                  {PageData?.PanelHeaderSettlementOffer}
                </p>
              ) : (
                <p className="settlementAgreed__message">
                  {PageData?.PanelHeader}
                </p>
              )}
              {(!isNullOrWhiteSpace(PageData?.PanelInformationText) ||
                Model?.IsInEditMode) && (
                <p className="CreateRepaymentPlan__plainText">
                  {PageData?.PanelInformationText}
                </p>
              )}
              {Model?.IsManualPaymentMethod && (
                <>
                  <div className="u-textCenter">
                    <button
                      className="Button-host u-textdecoration u-textWeightBold"
                      onClick={() =>
                        AddToMonthlyCalendar(
                          Model?.CalendarFirstPayment,
                          Model?.CalendarLastPayment,
                          PageData?.CalendarTitleMessage,
                          calenderDescription.__html
                            .toString()
                            .replace(/<[^>]+>/g, '')
                            .replace(/&nbsp;/gi, ''),
                          Model?.LastPaymentValue > 0
                            ? Model?.NumberOfRegularPayments + 1
                            : Model?.NumberOfRegularPayments,
                        )
                      }
                    >
                      {PageData?.SetupCalendarText}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {currentMarket !== Market.PL &&
          currentMarket !== Market.BE &&
          currentMarket !== Market.NL && (
            <>
              <>
                <h2 className={styles.heading}>
                  <span>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/payment-check.svg`}
                      width="24"
                    />
                  </span>
                  {Model.ForOffer || Model.IsInEditMode
                    ? PageData?.PaymentplanConfirmedSettlementOffer
                    : PageData?.PaymentPlanConfirmed}
                </h2>
                <div className={styles.summarycontainer}>
                  <p
                    className={styles.para}
                    dangerouslySetInnerHTML={{
                      __html: Model?.ChoosingPaymentMethodMessage,
                    }}
                  />

                  {Model?.IsManualPaymentMethod ? (
                    <p
                      className={styles.para}
                      dangerouslySetInnerHTML={{
                        __html: planDueDateManualTemplate
                          ? planDueDateManualTemplate({
                              DueDate: Model?.FirstPayment,
                            })
                          : '',
                      }}
                    />
                  ) : (
                    <p
                      className={styles.para}
                      dangerouslySetInnerHTML={{
                        __html: planDueDateTemplate
                          ? planDueDateTemplate({
                              DueDate: Model?.FirstPayment,
                            })
                          : '',
                      }}
                    />
                  )}

                  {Model?.IsManualPaymentMethod && (
                    <p className={styles.para}>
                      {PageData?.PaymentInfoReturnMessage}
                    </p>
                  )}

                  {Model?.PlanReviewDurationMonths && (
                    <p
                      className={styles.para}
                      dangerouslySetInnerHTML={{
                        __html: installmentMonthTemplate
                          ? installmentMonthTemplate({
                              InstallmentMonth: Model?.PlanReviewDurationMonths,
                            })
                          : '',
                      }}
                    />
                  )}

                  {Model?.IsManualPaymentMethod && (
                    <div className="u-textCenter">
                      <button
                        className="Button-host u-textdecoration u-textWeightBold"
                        onClick={() =>
                          AddToMonthlyCalendar(
                            Model?.CalendarFirstPayment,
                            Model?.CalendarLastPayment,
                            PageData?.CalendarTitleMessage,
                            calenderDescription.__html
                              .toString()
                              .replace(/<[^>]+>/g, '')
                              .replace(/&nbsp;/gi, ''),
                            Model?.LastPaymentValue > 0
                              ? Model?.NumberOfRegularPayments + 1
                              : Model?.NumberOfRegularPayments,
                          )
                        }
                      >
                        {PageData?.SetupCalendarText}
                      </button>
                    </div>
                  )}
                </div>
              </>
            </>
          )}

        <section className="CreateRepaymentPlan__section u-paddingHz">
          <div className="Repaymentlist">
            <div className="Repaymentlist__wrapper">
              <h4 className="Repaymentlist__heading">
                {PageData?.PaymentPlanTableHeader}
              </h4>
              <div
                className="Repaymentlist__grid"
                style={{ gridTemplateColumns: 'repeat(5, 1fr)' }}
              >
                {!isNullOrWhiteSpace(Model?.AccountLegacyId) && (
                  <div className="Repaymentlist__gridCell">
                    <span className="Repaymentlist__label">
                      {PageData?.AccountLegacyIdLabel}
                    </span>
                    <span className="Repaymentlist__value">
                      {Model?.AccountLegacyId}
                    </span>
                  </div>
                )}
                <div className="Repaymentlist__gridCell">
                  <span className="Repaymentlist__label">
                    {PageData?.DebtBalance}
                  </span>
                  <span
                    className={
                      'Repaymentlist__value' +
                      (Model.DiscountedDebtBalance > 0 ? ' u-lineThrough' : '')
                    }
                  >
                    {Model?.FormattedCurrencyDebtBalance}
                  </span>
                </div>
                {Model.DiscountedDebtBalance > 0 && (
                  <div className="Repaymentlist__gridCell">
                    <span className="Repaymentlist__label">
                      {PageData.DiscountedDebtBalance}
                    </span>
                    <span className="Repaymentlist__value">
                      {Model?.FormattedCurrencyDiscountedDebtBalance}
                    </span>
                  </div>
                )}

                <div className="Repaymentlist__gridCell">
                  <span className="Repaymentlist__label">
                    {PageData.RegularPaymentValueLabel}
                  </span>
                  <span className="Repaymentlist__value">
                    {Model.NumberOfRegularPayments} &times;&nbsp;
                    {Model?.FormattedCurrencyRegularPayment}
                  </span>
                </div>
                {Model.LastPaymentValue > 0 && (
                  <div className="Repaymentlist__gridCell">
                    <span className="Repaymentlist__label">
                      {PageData?.LastPaymentValueLabel}
                    </span>
                    <span className="Repaymentlist__value">
                      {Model?.FormattedCurrencyLastPayment}
                    </span>
                  </div>
                )}
                <div className="Repaymentlist__gridCell">
                  <span className="Repaymentlist__label">
                    {PageData?.PaymentMethod}
                  </span>
                  <span className="Repaymentlist__value">
                    {Model?.PaymentMethodName}
                  </span>
                </div>
                <div className="Repaymentlist__gridCell">
                  <span className="Repaymentlist__label">
                    {PageData?.FirstPayment}
                  </span>
                  <span className="Repaymentlist__value">
                    {Model?.FirstPayment}
                  </span>
                </div>
                <div className="Repaymentlist__gridCell">
                  <span className="Repaymentlist__label">
                    {PageData?.LastPayment}
                  </span>
                  <span className="Repaymentlist__value">
                    {Model?.LastPayment}
                  </span>
                </div>
                {Model?.ExternalPaymentReference && (
                  <div className="Repaymentlist__gridCell">
                    <span className="Repaymentlist__label">
                      {PageData?.ExternalPaymentReference}
                    </span>
                    <span className="Repaymentlist__value">
                      {Model?.ExternalPaymentReference}
                    </span>
                  </div>
                )}
              </div>
              <div className="Repaymentlist__ctaWrapper print_icon_mobile ">
                <ReactToPrint
                  trigger={() => (
                    <a className="Link-icon Link-print">
                      <>{PageData.PrintButtonLabel}</>
                    </a>
                  )}
                  content={() => componentRef.current}
                />
                <div style={{ display: 'none' }}>
                  <PrintPaymentPlanSummary ref={componentRef} {...props} />
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
};
export default PaymentSummaryDetails;
